import { mapPractitionersToForm } from '../../../lib/Proxy/user.js'

import * as Actions from './actions.js'

const initialState = {
  loading: true,
  error: false,
  practitioners: [],
  adminUsers: [],
  current_user: {},
  instances: []
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.PRACTITIONERS:
      return {
        ...initialState,
        loading: true
      }
    case Actions.PRACTITIONERS_SUCCESS: {
      const practitioners = mapPractitionersToForm(action.results)
      const user = practitioners.find(
        practitioner => practitioner.id === action.current_user.profile.sub
      )

      return {
        ...state,
        loading: false,
        error: false,
        practitioners,
        current_user: user
      }
    }
    case Actions.PRACTITIONERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        practitioners: []
      }
    case Actions.FETCH_INSTANCES_SUCCESS:
      return {
        ...state,
        instances: action.data
      }
    default:
      return state
  }
}
